<template>
    <template v-if="loading">
        <Loader />
    </template>
    <div class="col-md-12 col-lg-12 col-xl-9">
        <div class="sport-menu-tabs-sec walletHitory-container">

            <!-- ***wallet history start here*** -->
            <WalletHeader/>
            <section class="recent-wrapper walletPage-wrap">
               <div class="container">
                    <div class="payment-heading">
                        <h3>{{$t('transactions', 'Transactions')}}</h3>
                        <a class="filter-sec" href="#history-filter-modal" data-bs-toggle="modal">
                            <img loading="lazy" src="@/assets/images/filter.svg" alt="img">
                        </a>
                    </div>
                    <div class="account-table withdrow_table table-responsive report-table">
                        <table class="table table-bordered account-table-new text-white" id="depositTable">
                            <thead>
                                <tr>
                                    <th class="text-center">{{ $t('request-date', 'Request Date') }}</th>
                                    <th class="text-center">{{ $t('payment-type', 'Payment Type') }}</th>
                                    <th>{{ $t('payment-method', 'Payment Method') }}</th>
                                    <th class="text-center">{{ $t('requested-amount', 'Requested Amount') }}</th>
                                    <th class="text-center">{{ $t('status', 'Status') }}</th>
                                    <th class="text-center">{{ $t('approved-amount', 'Approved Amount') }}</th>                                                                        
                                    <th class="text-center">{{ $t('action-date', 'Action Date') }}</th>
                                    <th class="text-center">{{ $t('transaction-no', 'Transaction No') }}</th>
                                    <th class="text-center">{{ $t('reason', 'Reason') }}</th>
                                    <th>{{ $t('attachments', 'Attachments') }}</th>
                                    
                                </tr>
                            </thead>
                            <tbody v-if="historyData && historyData.length > 0" id="depositTableData">
                                <tr v-for="item in historyData" :key="item" class="text-center">
                                    <td>{{ item?.created_at?$dateTime?.getLocalDate(item?.created_at, 'DD/MM/YYYY HH:mm:ss'):'-' }}</td>
                                    <td>{{ toTitleCaseWithSpaces(item?.type) || '-' }}</td>
                                    <td >{{ item?.payment_method || '-' }}</td>
                                    <td>{{ item?.amount || '-'}}</td>
                                    <td class="text-start">
                                        <div class="d-flex align-items-center">
                                            <span class="depositStatus" :class="getTransactionStatus(item?.status)?.class" >
                                                {{ getTransactionStatus(item?.status)?.label  }}
                                            </span>
                                            <i v-if="['pending', 'approve_in_process', 'reject_in_process','hold'].includes(item.status)" @click="getWalletHistory(item)" :class="['fa', 'fa-refresh', {'fa-spin': selectedRequest?.c_a_tid == item?.c_a_tid?spinClass:false}]" aria-hidden="true" class="me-1 ms-1"></i>&nbsp;
                                        </div>
                                    </td>
                                    <td>{{item?.approved_amount || '-'}}</td>
                                    <td>{{ item?.action_at?$dateTime?.getLocalDate(item?.action_at, 'DD/MM/YYYY HH:mm:ss'):'-' }}</td>
                                    
                                    <td>{{ item?.transaction_id || '-'}}</td>
                                    <td class="remarkTD">{{item.remark ? ShowNote(item.remark) : '-'}}</td>
                                    <td :class="{'tran-view-btn-sec': item.transaction_image_url}">
                                        <button v-if="item.transaction_image_url" type="button" class="thm-but thm-bor-but" :class="{'view-tran-btn12': item?.transaction_image_url}" @click="item?.transaction_image_url && openTransactionDetails(item)">View Details</button>
                                        <span v-else>-</span>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody  v-if="!loading && historyData?.length == 0">
                                <tr>
                                    <td colspan="10" class="text-start">
                                        {{$t('no-records-found', "No Record found")}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </div>
        <Support></Support>
    </div>
    <div class="modal fade modal-style history-filter-modal" id="history-filter-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">{{$t('filters', 'Filter')}}</h3>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" @click="tempSelectedStatus = selectedStatus,tempSelectedStatus ='all',requestOptionTempSelectedStatus='all'" aria-label="Close">&#10006;</button>
                </div>
                <div class="modal-body">
                    <div class="filter-form-content">
                        <div class="wallet-filter-row">
                            <div class="input-field">
                                <label class="form-label">{{ $t('from','From')}}</label>
                                <input type="date" class="form-control" @input="preventClearFromDate" placeholder="30-05-23" aria-label="Username" id="exampleInputFrom" aria-describedby="addon-wrapping" v-model="formDates.fromDate">
                            </div>
                            <div class="input-field">
                                <label class="form-label">{{ $t('to','To')}}</label>
                                <input type="date" class="form-control" @input="preventClearToDate" placeholder="30-05-23" aria-label="Username" id="exampleInputTo" aria-describedby="addon-wrapping" v-model="formDates.toDate">
                            </div>
                        </div>
                        <div class="input-field">
                            <label class="form-label">{{ $t('filter-by','Filter By')}}</label>
                            <div class="wallet-filter-radio">
                                <div class="form-check" v-for="(item, index) in options" :key="index">
                                    <input class="form-check-input" type="radio" name="filter-method"
                                    :id="'checkbox-' + item.value" :value="item.value" ref="statusOpted" v-model="tempSelectedStatus">
                                    <label class="form-check-label" :for="'checkbox-' + item.value">
                                        {{ item.label }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="horizontal-diveder">
                            <hr>
                        </div>
                        <div class="input-field">
                            <label class="form-label">{{ $t('filter-by-request','Filter By Request')}}</label>
                            <div class="wallet-filter-radio">
                                <div class="form-check" v-for="(item, index) in requsetOptions" :key="index">
                                    <input class="form-check-input" type="radio" name="filter-methodd"
                                    :id="'checkbox-' + item.value" :value="item.value" ref="statusOpted" v-model="requestOptionTempSelectedStatus">
                                    <label class="form-check-label" :for="'checkbox' + item.value">
                                        {{ item.label }}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="header-but  info-footer">
                            <a href="javascript:void(0)" class="thm-but" @click="applyFilters()" data-bs-dismiss="modal" >{{$t('apply', 'Apply')}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="attchmentPreviewModal" tabindex="-1" aria-labelledby="qrPreviewLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header p-0 border-0">
                    <div class="searchbar-main deposit-page-close">
                        <button type="button" class="closebtn-searchh deposit-page-close-btn" data-bs-dismiss="modal">
                            ✖
                        </button>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="qrPreview-image d-flex flex-wrap">
                        <div v-for="(image, index) in transactionImageLists" :key="index" class="transactionImage-item">
                             <a :href="image" target="_blank" download>
                                <img :src="image" alt="image" class="img-fluid w-100 rounded">
                             </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Confirmation @confirm="confirmDelete" @cancel="$helper.closeModal('deleteConfirmationModal')"/>  
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { getWalletHistory, cancelRequest, getTransactionStatus } from '../services/walletHistory';
import Loader from '@/shared/components/loader/Loader.vue';
import Confirmation from '@/shared/components/modal/Confirmation.vue';
import Pagination from '@/modules/statment/components/Pagination.vue';
import WalletHistoryFilter from '../components/WalletHistoryFilter.vue';
import WalletHeader from '../components/WalletHeader.vue';
import SportSelection from '@/shared/components/sport-selection/SportSelection.vue';
import Banner from '@/shared/components/banner/Banner.vue';
import Support from '@/shared/components/support/Support.vue';
export default {
    name: 'WalletHistory',
    components: {
        Support,
        Banner,
        SportSelection,
        WalletHeader,
        WalletHistoryFilter,
        Pagination,
        Confirmation,
        Loader,
    },
   data() {
        return {
            walletHistoryData: null,
            pageNo: 1,
            currentImgLink: null,
            totalPage: 0,
            pageEntries: 25,
            formDates:{
                fromDate: '',
                toDate: '',
            },
            requsetOptions:[
                { label: this.$t('ALL', 'All'), value: 'all', selected:true },
                { label: this.$t('deposit', 'Deposit'), value: 1, selected:true },
                { label: this.$t('withdrawal', 'Withdrawal'), value: 2, selected:true },
            ],
            options: [
                { label: this.$t('ALL', 'All'), value: 'all', selected:true },
                { label: this.$t('approved', 'Approved'), value: 1, selected:true },
                { label: this.$t('rejected', 'Rejected'), value: 2, selected:true },
                { label: this.$t('Processing', 'Processing'), value: 5, selected:true },
                { label: this.$t('pending', 'Pending'), value: 0, selected:true },
                { label: this.$t('expired ', 'Expired '), value: 3, selected:true },
            ],
            selectedStatus: 'all',
            tempSelectedStatus: 'all',
            requestOptionSelectedStatus:'all',
            requestOptionTempSelectedStatus: 'all',
            loading: false,
            spinClass: false,
            from: 0,
            selectedRequest:null,
            to: 0,
            total: 0,
            lastPage: 0,
            transactionImageLists:null,
            selectedTransactionId: null,
        }
    },
    created() {
        if(this.$auth.user.isDemo){
            this.$errorToast("Wallet access is restricted for demo user");
            setTimeout(() => {
                this.$router.push({name: 'Home'})
            }, 500);
        }
        const previousDate = this.$dateTime.getPreviousDate(2);
        this.formDates.fromDate = previousDate
        const currentDate =this.$dateTime.getcurrentDate() 
        this.formDates.toDate = currentDate;
        this.selectedStatus = 'all';
        this.tempSelectedStatus = 'all';
        this.requestOptionTempSelectedStatus = 'all'
        this.getWalletHistory()
    },
    computed: {
        historyData() {
            return this.walletHistoryData;
        },
    },
    methods: {
       openTransactionDetails(item) {
            this.transactionImageLists = item?.transaction_image_url?.split(',')
            this.$helper.openModal('#attchmentPreviewModal')
        }, 
        preventClearFromDate(event) {
            if (!event.target.value) {
                this.formDates.fromDate = this.$dateTime.getPreviousDate(2);
            }
        },
        askConfirmation(id) {
            this.selectedTransactionId = id
            this.$helper.openModal('#deleteConfirmationModal')
        },
        async confirmDelete() {
            this.$helper.closeModal('deleteConfirmationModal')
            await cancelRequest(this.selectedTransactionId);
            this.getWalletHistory()
        },
        ShowNote(txt){
            if(txt == 'null' || txt == '' || txt == null) 
                return '-';
            else
                return txt;
        },
        preventClearToDate(event) {
            if (!event.target.value) {
                this.formDates.toDate = this.$dateTime.getcurrentDate()
            }
        },
        prevPage(){
            this.pageNo>1 ? this.pageNo = this.pageNo - 1 : this.pageNo = 1;
            this.getWalletHistory();
        },
        nextPage(){
            this.pageNo<this.lastPage ? this.pageNo = this.pageNo + 1 : this.pageNo = this.lastPage;
            this.getWalletHistory();
        },
        applyFilters() {
            this.pageNo = 1;
            this.selectedDates = {
                fromDate: this.formDates.fromDate,
                toDate: this.formDates.toDate,
            },
            this.selectedStatus = this.tempSelectedStatus;
            this.requestOptionSelectedStatus = this.requestOptionTempSelectedStatus;
            this.getWalletHistory();
        },
        toTitleCaseWithSpaces(str) {
            return str.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
        },
        async getWalletHistory(request  = null) {
            try{
                this.loading = true
                this.selectedRequest = request
                this.spinClass = true;
                // this.$store.dispatch('setGlobalLoader', true);
                let response = await getWalletHistory(this.formDates)
                // this.$store.dispatch('setGlobalLoader', false);
                setTimeout(()=>{
                    this.spinClass = false;
                },500)
                if(response){
                    this.loading = false
                    this.walletHistoryData = JSON.parse(JSON.stringify(response?.walletHistoryData));
                    console.log(this.walletHistoryData,response);
                    if(this.selectedStatus == 'all'){
                        this.walletHistoryData = JSON.parse(JSON.stringify(this.walletHistoryData.filter((history) => ['pending','hold','approve_completed','approve_in_process','reject_completed','reject_in_process','expired'].includes(history.status))))
                    }
                    if(this.selectedStatus == 0){
                        this.walletHistoryData = JSON.parse(JSON.stringify(this.walletHistoryData.filter((history) => ['pending'].includes(history.status))))
                    }
                    else if(this.selectedStatus == 1){
                        this.walletHistoryData = JSON.parse(JSON.stringify(this.walletHistoryData.filter((history) => ['approve_completed'].includes(history.status))))
                    }
                    else if(this.selectedStatus == 2){
                        this.walletHistoryData = JSON.parse(JSON.stringify(this.walletHistoryData.filter((history) => ['reject_completed','reject_in_process'].includes(history.status))))
                    }
                    else if(this.selectedStatus == 3){
                        this.walletHistoryData = JSON.parse(JSON.stringify(this.walletHistoryData.filter((history) => ['expired'].includes(history.status))))
                    }
                    else if(this.selectedStatus == 4){
                        this.walletHistoryData = JSON.parse(JSON.stringify(this.walletHistoryData.filter((history) => ['hold'].includes(history.status))))
                    }
                    else if(this.selectedStatus == 5){
                        this.walletHistoryData = JSON.parse(JSON.stringify(this.walletHistoryData.filter((history) => ['approve_in_process','reject_in_process','hold'].includes(history.status))))
                    }
                    if(this.requestOptionSelectedStatus == 'all'){
                        this.walletHistoryData = JSON.parse(JSON.stringify(this.walletHistoryData.filter((history) => ['client_deposit','client_withdrawal'].includes(history.history.type))))
                    }else if(this.requestOptionSelectedStatus == 1){
                        this.walletHistoryData = JSON.parse(JSON.stringify(this.walletHistoryData.filter((history) => ['client_deposit'].includes(history.type))))
                    }else if(this.requestOptionSelectedStatus == 2){
                        this.walletHistoryData = JSON.parse(JSON.stringify(this.walletHistoryData.filter((history) => ['client_withdrawal'].includes(history.type))))
                    }
                }
            }catch(error){
                this.loading = false
                setTimeout(()=>{
                    this.spinClass = false;
                },500)
                // this.$store.dispatch('setGlobalLoader', false);
                console.log(error)
            }
        },
        getRequestType(type){
            switch (type) {
                case 1 :
                    return 'Create Id';
                case 2 :
                    return 'Deposit';
                case 3 :
                    return 'Withdraw';
                case 4 :
                    return 'Transfer Fund';
                case 5 :
                    return 'Forgot Password';
                case 6 :
                    return 'Close Id';
                case 7 :
                    return 'Id Bonus';
                case 8 :
                    return 'Referral';
                case 9 :
                    return 'Referral Debit';
            }
        },
        getTransactionStatus,
        // getTransactionStatus(status){
        //     switch (status) {
        //         case 0 :
        //             return 'Pending';
        //         case 1 :
        //             return 'Approved';
        //         case 2 :
        //             return 'Rejected';
        //         case 3 :
        //             return 'Canceled';
        //         case 4 :
        //             return 'Processing';
        //     }
        // },
        gotoTransactionDetails(transaction){
            if(this.selectedStatus == 0) {return; };
            this.$store.dispatch('setWalletDetails', {...transaction, status: this.selectedStatus});
            this.$router.push({ 
                name: 'wallet-history-detail', 
                params: { id: transaction.id } 
            })
        },
    },

}
</script>

<style>
.bg-yellow{
    background: #ffbf00 !important;
}
.bg-red{
    background: red !important;
}
</style>